import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ArrowsTriangle = function ArrowsTriangle(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "m18 5-1.0981 4.0981-4.0981-1.098M2 11.5981 6.098 10.5l1.0982 4.0981M15.5 22l-3-3 3-3"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13 19h4.2942c1.8652 0 2.7978 0 3.3273-.3908a1.9999 1.9999 0 0 0 .8048-1.4349c.0573-.6556-.429-1.4514-1.4016-3.043L19.0278 12.5M6.1301 10.6052l-2.1548 3.5262c-.9726 1.5915-1.459 2.3873-1.4016 3.0429a2 2 0 0 0 .8048 1.4349C3.908 19 4.8405 19 6.7058 19H8.5m8.3889-10-2.1584-3.532c-.9028-1.4772-1.3542-2.2159-1.9353-2.4677a2 2 0 0 0-1.5904 0c-.5811.2518-1.0325.9905-1.9353 2.4678L8.2497 7.1369M18 5l-1.0981 4.098L12.8038 8M2 11.598 6.098 10.5l1.0982 4.0981M15.5 22l-3-3 3-3"
    })]
  }));
};
export default ArrowsTriangle;